import { PageDefinition } from "@cervval.js/client-html5-spa/navigation";
import { ObjectTools } from "@cervval.js/common/tools";
import { CONNECTED_PS } from "@ehealth_tools/common-booking/src/permissions/permissionString";
import { BookingPages } from "../../../page.i18n";

export const proBookingPages = {
    "booking": ObjectTools.is<PageDefinition>({
        importPromise: () => { return import("./bookingPage").then((module) => new module.BookingPage()); },
        menuItem: {
            label: BookingPages().myAgenda,
            iconClasses: "fa-regular fa-calendar fa-xl"
        },
        menus: [],
        permissions: [CONNECTED_PS]
    })
};